import { type FocusEvent } from 'react';
import { Controller, type Control } from 'react-hook-form';

import { useTranslate, type CardOptionType } from 'hooks';
import type { PaymentType } from 'types';

import type { InputTypePropTypes } from '../input-type';

import type { InputPropTypes, CardFieldsType } from './type';

type Props = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  paymentData: PaymentType;
  amount: string;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
  InputComponent: React.ForwardRefExoticComponent<
    InputPropTypes & InputTypePropTypes & React.RefAttributes<HTMLInputElement>
  >;
};

const NameInput = ({
  control,
  selectedCard,
  paymentData,
  amount,
  InputComponent,
  onHandleFocus,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Controller
      name="name"
      control={control}
      rules={
        selectedCard.newCard
          ? {
              required: true,
              minLength: 1,
            }
          : undefined
      }
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <InputComponent
          placeholder={t('1xbet.card-name')}
          name="name"
          inputClassName="w-full"
          value={
            selectedCard.newCard ? value.toUpperCase() : (selectedCard.name ?? '').toUpperCase()
          }
          ref={ref}
          onFocus={onHandleFocus}
          onChange={onChange}
          error={error?.message}
          disabled={paymentData.commission > amount || !selectedCard.newCard}
        />
      )}
    />
  );
};

export { NameInput };
